/** @format */
import { chain } from '@/utils';

// 从checkRows格式中获取formDatas格式数据
export const getCheckRowsToFormDatas = (linkConfig, flatWigetDatas, checkRows) => {
	return linkConfig.reduce((obj, item) => {
		const code = flatWigetDatas.find((itm) => itm.code === item.code)?.options?.code;
		const value = checkRows.map((itm) => chain(itm, item.link)).toString();
		return { ...obj, [code]: value };
	}, {});
};

// 从formDatas格式数据中获取字符串结构数据
export const getFormDatasToStrArr = (linkConfig, flatWigetDatas, formDatas) => {
	return linkConfig.reduce((obj, item) => {
		const code = flatWigetDatas.find((itm) => itm.code === item.code)?.options?.code;
		const value = formDatas[code] ? formDatas[code].split(',') : [];
		if (value.length) {
			value.forEach((itm, idx) => {
				obj[idx] = obj[idx] ? `${obj[idx]},${itm}` : itm;
			});
		}
		return obj;
	}, []);
};

// 从字符串结构数据获取formDatas格式数据
export const getStrArrToFormDatas = (linkConfig, flatWigetDatas, strArr) => {
	const keys = linkConfig.map((i) => flatWigetDatas.find((itm) => itm.code === i.code)?.options?.code);

	if (strArr.length) {
		return strArr.reduce((obj, item) => {
			const value = item.split(',');
			value.forEach((itm, idx) => {
				obj[keys[idx]] = obj[keys[idx]] ? `${obj[keys[idx]]},${itm}` : itm;
			});
			return obj;
		}, {});
	} else {
		const obj = {};
		keys.forEach((itm) => {
			obj[itm] = '';
		});
		return obj;
	}
};
